import { useCallback, useEffect, useRef, useState } from "react";
import { appHistoryReplaceWithSearchParams } from "../../app/appHistory";

export const useInitZendeskScript = (zendeskSnippetKey) => {
    const [isWebWidgetInited, setIsWebWidgetInited] = useState(false);
    const onWidgetCloseCallback = useRef(null);

    const setOnWidgetCloseCallback = useCallback((callback) => {
        onWidgetCloseCallback.current = callback;
    }, []);

    useEffect(() => {
        let script
        if (zendeskSnippetKey) {
            const url = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskSnippetKey}`;
            script = document.createElement('script')
            script.src = url;
            script.id = 'ze-snippet';
            script.async = true;
            document.body.appendChild(script);
            script.onload = function () {
                if (window.zE) {
                    window.zE('webWidget', 'hide');
                    window.zE('webWidget:on', 'close', function () {
                        window.zE('webWidget', 'hide');
                        appHistoryReplaceWithSearchParams({'support-widget': null});
                        if (typeof onWidgetCloseCallback.current === 'function' ) {
                            onWidgetCloseCallback.current();
                        }
                    })
                    setIsWebWidgetInited(true)
                }
            }
            return () => {
                document.body.removeChild(script);
            }
        }
    }, [zendeskSnippetKey])
    return { isWebWidgetInited, setOnWidgetCloseCallback }
}

export const usePrefillEmail = (isWebWidgetInited, userEmail) => {
    useEffect(() => {
        if (isWebWidgetInited && window.zE) {
            if (userEmail) {
                window.zE('webWidget', 'prefill', {
                    email: {
                        value: userEmail,
                        readOnly: true,
                    }
                });
            } else {
                window.zE('webWidget', 'reset');
                window.zE('webWidget', 'prefill', {
                    email: {
                        readOnly: false,
                    }
                });
            }
        }
    },[isWebWidgetInited, userEmail]);
}
